import { Fragment } from 'react';
import type { HeroDarkData } from './schema';

export function HeroDarkRenderer({
  videoSrc,
  posterSrc,
  h1Top,
  h1Highlight,
  h1Mute,
  sub,
  ctaPrimary,
  ctaSecondary,
  miniStats,
  showScrollCue = true,
}: HeroDarkData) {
  return (
    <section className="v4-hero">
      {videoSrc ? (
        <video
          className="v4-hero-video"
          autoPlay
          muted
          loop
          playsInline
          poster={posterSrc}
        >
          <source src={videoSrc} type="video/mp4" />
        </video>
      ) : null}
      <div className="v4-hero-overlay"></div>
      <div className="v3-hero-orb v3-orb-1"></div>
      <div className="v3-hero-orb v3-orb-2"></div>
      <div className="container v3-hero-inner v4-hero-inner">
        <h1 className="v3-h1">
          {h1Top ? (
            <>
              {h1Top}
              <br />
            </>
          ) : null}
          <span className="v3-h1-hl">{h1Highlight}</span>
          {h1Mute ? (
            <>
              <br />
              <span className="v3-h1-mute">{h1Mute}</span>
            </>
          ) : null}
        </h1>
        {sub ? <p className="v3-hero-sub">{sub}</p> : null}
        {(ctaPrimary || ctaSecondary) && (
          <div className="v3-hero-ctas">
            {ctaPrimary ? (
              <a href={ctaPrimary.href} className="v3-btn v3-btn-primary v3-btn-lg">
                {ctaPrimary.label} →
              </a>
            ) : null}
            {ctaSecondary ? (
              <a href={ctaSecondary.href} className="v3-btn v3-btn-ghost v3-btn-lg">
                {ctaSecondary.label}
              </a>
            ) : null}
          </div>
        )}
        {miniStats && miniStats.length > 0 ? (
          <div className="v3-hero-mini-stats">
            {miniStats.map((s, i) => (
              <Fragment key={i}>
                <div>
                  <strong>{s.value}</strong>
                  {s.label}
                </div>
                {i < miniStats.length - 1 ? <div className="v3-divider"></div> : null}
              </Fragment>
            ))}
          </div>
        ) : null}
      </div>
      {showScrollCue ? (
        <div className="v4-scroll-cue">
          <span></span>
          <span className="v4-scroll-text">Scroll</span>
        </div>
      ) : null}
    </section>
  );
}
